import urls from "../utils/urls"
import { post} from '../utils/http'
const state= {
    
    result:{},
  
    code:0
    
}
const mutations={
   
  
    getOrderService(state,value){
        
        
       
        post(urls.admin.order_service.index,value).then((result)=>{
          
          
          
          state.result=result

        
        
       
        
       
           
        });
        
    },
    addOrderService(state,value){
        
        
    
        post(urls.admin.order_service.add,value).then((result)=>{
          
          
          
          state.result=result

        
        
       
        
       
           
        });
        
    },
    editOrderService(state,value){
        
        
    
        post(urls.admin.order_service.edit,value).then((result)=>{
          
          
          
          state.result=result

        
        
       
        
       
           
        });
        
    },
    getOrderProfitsDetail(state,value){
        
        
       
        post(urls.admin.order_profits.detail,value).then((result)=>{
          
          
          
          state.result=result
        
       
        
       
           
        });
        
    },
  
    
   

    

}
const  actions={
    getOrderServiceAction(context,value){
       
        context.commit("getOrderService",value)
       
    },
    addOrderServiceAction(context,value){
       
        context.commit("addOrderService",value)
       
    },
    getOrderProfitsDetailAction(context,value){
       
        context.commit("getOrderProfitsDetail",value)
       
    },

    editOrderServiceAction(context,value){
      
        context.commit("editOrderService",value)
       
    },
    
  
  
    
   

}

export default {state,mutations,actions}